import { logStartGreyError } from 'owa-analytics-start';
import { getRawStoreInternalOnly } from '../store/store';
import tryGetGlobalSettingsAccountMailboxInfo from 'owa-account-source-list-store/lib/selectors/tryGetGlobalSettingsAccountMailboxInfo';

export function checkGlobalSettingsReady(context?: string): void {
    const { allowDefaultDataReturn, userConfiguration } = getRawStoreInternalOnly();
    if (!allowDefaultDataReturn && userConfiguration === undefined) {
        const error = new Error('OwaSessionStoreGlobalSettingsNotReady');

        logStartGreyError(
            'OwaSessionStoreGlobalSettingsNotReady',
            tryGetGlobalSettingsAccountMailboxInfo(),
            error,
            { context }
        );
    }
}
